module.exports = __webpack_public_path__ + "static/media/check.43751db6.svg";